'use strict';
import angular from 'angular';

export default class AppGreenBackgroundController {
    /*@ngInject*/
    constructor($stateParams, $http, $state, Application, $scope, Upload) {
        var vm = this;

		//$('.bslider').bootstrapSlider();


        vm.rows = [];

        vm.fileUploadTime = Date.now();

        $http.get('/api/applications/' + $stateParams.id).then(
            function(res) {
                var data = res.data;
                Application.load($stateParams.id).then(function() {
                    $scope.$apply(function() {
                        vm.app = Application;
                        vm.rows = Application.general.greenBackground;
                    }); 
                    
                });
				
            }, function(error) {
                if (error.status == "404") {
                    $state.go('application_main');
                }
                console.log(error);
            });

		
		vm.save = function() {
			Application.save($stateParams.id);
		}
        

        vm.addLine = function() {
            Application.general.greenBackground.push(vm.rows.length +1)
            vm.rows = Application.general.greenBackground;
        }

        vm.deleteLine = function(row) {
            $http.post('api/applications/element', {id:$stateParams.id, index : (vm.rows.indexOf(row) +1),path:"/public/applications/" + $stateParams.id + "/interface/backgrounds/print/" + "bg_"+(vm.rows.indexOf(row) +1)+".jpg"}).then(function(){
                Application.general.greenBackground.splice(vm.rows.indexOf(row), 1);
                vm.rows = Application.general.greenBackground;
                Application.save($stateParams.id).then(function(){
                    location.reload();
                });
            })
        }

        vm.next = function() {
			Application.next($stateParams.id);
		}

        vm.upload = function (file, name) {
            Upload.upload({
                url: '/api/applications/'+$stateParams.id+'/upload/' + name,
                data: {file: file}
            }).then(function (resp) {
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                vm.fileUploadTime = Date.now();
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };

        vm.uploadElem = function (file, path) {
            Upload.upload({
                url: '/api/applications/'+$stateParams.id+'/upload',
                data: {file: file, path : path}
            }).then(function (resp) {
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                vm.fileUploadTime = Date.now();
                Application.save($stateParams.id);
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };
    }

}


// WEBPACK FOOTER //
// ./client/app/application/greenBackground/greenBackground.controller.js